// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Code d'erreur :",
    "error.search": "Consultez notre base de connaissances pour en savoir plus",
    dismiss: "ignorer",
    "installation.title": "",
    "cancelation.button": "Annuler",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Échec de l'initialisation",
      description:
        "Nous n'avons pu rendre la page. Veuillez contacter l'assistance.",
    },
    "EOS-UI-UE": {
      title: "Une erreur s'est produite.",
      description:
        "Une erreur s'est produite. Veuillez contacter l'assistance.",
    },
    "EOS-IN-BC": {
      title: "Échec de l'installation",
      description:
        "Nous n'avons pu afficher la progression de l'installation. Veuillez contacter l'assistance.",
    },
    "EOS-IN-UE": {
      title: "Échec de l'installation",
      description:
        "Une erreur s'est produite. Veuillez contacter l'assistance.",
    },
    "EOS-IN-FF": {
      title: "Échec de l'installation",
      description:
        "Nous n'avons pu nous connecter aux Epic Online Services. Veuillez contacter l'assistance.",
    },
    "EOS-IN-FF-*": {
      title: "Échec de l'installation",
      description:
        "Nous n'avons pu envoyer la demande aux Epic Online Services. Veuillez contacter l'assistance.",
    },
    fallback: {
      title: "Une erreur s'est produite.",
      description:
        "Une erreur s'est produite. Veuillez contacter l'assistance.",
    },
  },
};
